import { useState, useEffect, useRef } from 'react';
import {
  _getApplicationSettings,
  _upsertApplicationSettings,
} from 'controllers/applicationsettings/applicationsettings_controller';

export const useSettings = () => {
  const [settings, setSettings] = useState({
    'queue-status': null,
    'queue-distribution': '',
    'queue-reassignment-time': null,
    'queue-active-leads': null,
    'queue-automatic-balancing': null,
    'queue-max-lead-gap': null,
    'queue-balance-frecuency': null,
  });

  const debounceRefs = useRef({});

  /** Get queue settings from API and parse strings to js values */
  useEffect(() => {
    _getApplicationSettings().then((data) => {
      const newSettings = { ...settings };
      data.forEach((item) => {
        switch (item.name) {
          case 'queue-status':
            newSettings['queue-status'] = JSON.parse(item.value);
            break;
          case 'queue-distribution':
            newSettings['queue-distribution'] = item.value;
            break;
          case 'queue-reassignment-time':
            newSettings['queue-reassignment-time'] = Number(item.value);
            break;
          case 'queue-active-leads':
            newSettings['queue-active-leads'] = Number(item.value);
            break;
          case 'queue-automatic-balancing':
            newSettings['queue-automatic-balancing'] = JSON.parse(item.value);
            break;
          case 'queue-max-lead-gap':
            newSettings['queue-max-lead-gap'] = Number(item.value);
            break;
          case 'queue-balance-frecuency':
            newSettings['queue-balance-frecuency'] = Number(item.value);
            break;
          default:
            break;
        }
      });
      setSettings(newSettings);
    });
  }, []);

  const handleAppSetting = async (key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (debounceRefs.current[key]) {
      clearTimeout(debounceRefs.current[key]);
    }

    debounceRefs.current[key] = setTimeout(async () => {
      const toSave = typeof value === 'string' ? value : JSON.stringify(value);
      await _upsertApplicationSettings(key, toSave);
    }, 500);
  };

  return { settings, handleAppSetting };
};
